import { Box, Typography } from "@mui/material";
import { useSearchParams } from "react-router";
import { CardHeading, SecurityImage } from "@rentablo/components";
import { SingleSecurityPageActions } from "./SingleSecurityPageActions";

interface SingleSecurityPageProps {
  quoteName: string;
  quoteIsin: string;
  image?: string | null;
  tickerSymbol: string;
  hasWatchlists: boolean;
  onAddToWatchlist: () => void;
}

export const SingleSecurityPageHeader = ({
  quoteName,
  quoteIsin,
  image,
  tickerSymbol,
  hasWatchlists,
  onAddToWatchlist,
}: SingleSecurityPageProps) => {
  const [searchParams] = useSearchParams();
  const quoteProvider = searchParams.get("quoteProvider");

  return (
    <CardHeading
      actionsInline
      title={
        <Box display="flex" alignItems="center" gap={3} minWidth={0}>
          <Box display={{ xs: "none", sm: "block" }}>
            <SecurityImage src={image} alt={quoteName} />
          </Box>
          <Box sx={{ overflowWrap: "anywhere" }}>
            <Typography variant="h4" component="h1">
              {quoteName}
            </Typography>
            <Typography variant="body1" color="textSecondary">
              {quoteIsin}
            </Typography>
          </Box>
        </Box>
      }
      actions={
        <SingleSecurityPageActions
          quoteProvider={quoteProvider ?? ""}
          tickerSymbol={tickerSymbol}
          hasWatchlists={hasWatchlists}
          onAddToWatchlist={onAddToWatchlist}
        />
      }
    />
  );
};
